// extracted by mini-css-extract-plugin
export default {"container":"TopArrow_container__Esq3r","innerContainer":"TopArrow_innerContainer__bNayp","arrow":"TopArrow_arrow__82wuM"};